// Przeciążenie – meta tagi SEO dla strony 404 (noindex, nofollow)
// @ts-nocheck

import React from 'react';
import { Helmet } from 'react-helmet';

import { useAppNavigate } from 'hooks';

import { Button, Container } from 'components/controls';

import styles from 'theme/pages/NoMatch/NoMatch.module.scss';

interface IProps {
  // INHB-929: false, gdy widok pokazujemy przy błędzie innym niż 404 (np. awaria API) —
  // wtedy nie zgłaszamy botowi 404 ani nofollow, bo adres istnieje.
  withNotFoundStatus?: boolean;
}

const NoMatch = ({ withNotFoundStatus = true }: IProps) => {
  const navigate = useAppNavigate();

  return (
    <>
      <Helmet>
        <title>404 - Strona nie znaleziona</title>
        {withNotFoundStatus && <meta name="robots" content="noindex, nofollow" />}
        {/* INHB-929: prerender oddaje botom HTTP 404 zamiast 200 (soft 404) */}
        {withNotFoundStatus && <meta name="prerender-status-code" content="404" />}
      </Helmet>
      <Container>
        <div className={styles.componentWrapper}>
          <h1>404</h1>
          <h4>Nie znaleziono takiej strony</h4>
          <p>
            Przepraszamy, nie możemy znaleźć strony, której szukasz! Naciśnij przycisk poniżej, aby
            wrócić do strony głównej.
          </p>
          <Button onClick={() => navigate('/')}>Powrót do strony głównej</Button>
        </div>
      </Container>
    </>
  );
};

export default NoMatch;
